export default {"src":"/_next/static/image/public/images/flags/flag_386.54e909143e4981c9172c826d0e4881e8.svg","height":16,"width":24};